import { useTheme } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import type { FC, ReactNode } from 'react';
import type { AppTheme } from 'types/models';
import componentsOverride from './overrides';
import { themeOptions as apotheoThemeOptions } from './whiteLabel/apotheo';
import { themeOptions as gipharThemeOptions } from './whiteLabel/giphar';
import { themeOptions as lafThemeOptions } from './whiteLabel/laf';
import { themeOptions as pharmactivThemeOptions } from './whiteLabel/pharmactiv';
import { themeOptions as pharmavieThemeOptions } from './whiteLabel/pharmavie';
import { themeOptions as phrThemeOptions } from './whiteLabel/phr';
import { themeOptions as reseauSanteThemeOptions } from './whiteLabel/reseauSante';

type Props = {
  children: ReactNode;
  appTheme: AppTheme | undefined;
};

const themeOptionsByAppTheme = {
  apotheo: apotheoThemeOptions,
  giphar: gipharThemeOptions,
  laf: lafThemeOptions,
  pharmactiv: pharmactivThemeOptions,
  pharmavie: pharmavieThemeOptions,
  reseau_sante: reseauSanteThemeOptions,
  phr: phrThemeOptions,
} as const;

const WhiteLabelThemeProvider: FC<Props> = ({ children, appTheme }) => {
  const themeOptions = appTheme ? themeOptionsByAppTheme[appTheme] : {};
  const theme = createTheme(useTheme(), themeOptions);
  theme.components = componentsOverride(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default WhiteLabelThemeProvider;
